var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.005 12C8.55728 12 9.005 11.5523 9.005 11C9.005 10.4477 8.55728 10 8.005 10C7.45271 10 7.005 10.4477 7.005 11C7.005 11.5523 7.45271 12 8.005 12ZM8.075 9C8.595 9 9.035 8.6 9.075 8.07L9.295 5.07C9.335 4.49 8.875 4 8.295 4H7.705C7.125 4 6.665 4.49 6.705 5.07L6.925 8.07C6.965 8.6 7.405 9 7.925 9H8.075Z",
    fill: "#AD4040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputError);
export default __webpack_public_path__ + "static/media/input-error.d4620aea6b9deb1652420bd1fe2b2247.svg";
export { ForwardRef as ReactComponent };